import React, { useId } from 'react';

// Brand logo for Sinergie Generative — a generative "spark" inside a card,
// plus a Fraunces wordmark. Self-contained (brand colors baked in); pass
// `color` to override the wordmark ink (e.g. on dark backgrounds).
const CYAN = '#1FB6E8';
const CORAL = '#FF6A4D';
const INK = '#14181D';

export default function Logo({ height = 32, color = INK, wordmark = true }) {
  const gid = 'sg' + useId().replace(/:/g, '');
  const mark = (
    <svg width={height} height={height} viewBox="0 0 40 40" role="img" aria-label="Sinergie Generative" style={{ flexShrink: 0 }}>
      <defs>
        <linearGradient id={gid} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor={CYAN} />
          <stop offset="1" stopColor={CORAL} />
        </linearGradient>
      </defs>
      {/* card */}
      <rect x="3" y="3" width="34" height="34" rx="10" fill={`url(#${gid})`} />
      {/* 4-point generative spark */}
      <path
        d="M20 9 C21 16 24 19 31 20 C24 21 21 24 20 31 C19 24 16 21 9 20 C16 19 19 16 20 9 Z"
        fill="#fff"
      />
      {/* small synergy dot */}
      <circle cx="29.5" cy="10.5" r="2.4" fill="#fff" opacity="0.85" />
    </svg>
  );

  if (!wordmark) return mark;

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 9 }}>
      {mark}
      <span style={{ display: 'inline-flex', flexDirection: 'column', lineHeight: 1 }}>
        <span style={{ fontFamily: '"Fraunces", Georgia, serif', fontWeight: 800, fontSize: height * 0.62, color, letterSpacing: '-0.01em' }}>
          Sinergie
        </span>
        <span style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 700, fontSize: Math.max(11, height * 0.32), letterSpacing: '0.34em', color: CYAN, marginTop: 2 }}>
          GENERATIVE
        </span>
      </span>
    </span>
  );
}
